var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{key:_vm.field.prop,attrs:{"width":_vm.field.width,"sortable":_vm.field.sortable ? 'custom' : false,"label":_vm.field.label,"prop":_vm.field.prop},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.src(scope)}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }